<div class="settings-result">
  <div class="widget">
    <div class="head">
      <div class="row">
        <div class="col-md-12">
          <h1>Settings</h1>
        </div>
      </div>
      <app-media-category *ngIf="isSuperUser" [saleTemplateId]="0" [showAddButton]="true"></app-media-category>
      <app-sale-template *ngIf="isSalesCompany"></app-sale-template>
     <!-- <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="center"
        color="accent"
        #tabGroup
      >
        <mat-tab label="Name Management" >
          <app-media-category [saleTemplateId]="0" [showAddButton]="true"></app-media-category>
        </mat-tab>
        <mat-tab label="Template Management" >
          
        </mat-tab>
      </mat-tab-group>-->
    </div>
  </div>
</div>
